import { credentials } from '@shootsta/client-auth';

const getCurrentUserId = () => {
  const { user: { userId } = {} } = { user: {}, ...credentials.get() };

  return userId;
};

export default getCurrentUserId;